export const environment = {
  firebase: {
    //Audit dev key

    // apiKey: "AIzaSyCsfNLk5CogPR05YrgJ75Ygi7NOIvJelrY",
    // authDomain: "bwi-audit-dev.firebaseapp.com",
    // projectId: "bwi-audit-dev",
    // storageBucket: "bwi-audit-dev.appspot.com",
    // messagingSenderId: "712189090410",
    // appId: "1:712189090410:web:01b3ea2b4503da05764813",
    // measurementId: "G-87HX3VDC25"

    //Austrailian council Key
    apiKey: "AIzaSyAn3gPfdoX0ZZrbzBj70SxD_58BbtREI4A",
    authDomain: "australian-council.firebaseapp.com",
    projectId: "australian-council",
    storageBucket: "australian-council.appspot.com",
    messagingSenderId: "919797156885",
    appId: "1:919797156885:web:cdd180c9124410fc40921c",
    measurementId: "G-7WGHG0BQ9J"
  },
  cloudUrl:'https://us-central1-australian-council.cloudfunctions.net/'
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts